/* ═══════════════════════════════════════════════════════════════
   MAISON VELMONT — JavaScript
   ═══════════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  // ── Header scroll effect ─────────────────────────────────────
  const header = document.getElementById('site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Mobile menu ───────────────────────────────────────────────
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('open');
      menuToggle.classList.toggle('active', isOpen);
      menuToggle.setAttribute('aria-expanded', isOpen);
      mobileMenu.setAttribute('aria-hidden', !isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    // Close on link click
    mobileMenu.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        menuToggle.classList.remove('active');
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });
  }

  // ── Scroll reveal ─────────────────────────────────────────────
  const reveals = document.querySelectorAll(
    '.fp-visual, .fp-info, .collection-card, .spec-item, ' +
    '.manifeste-quote, .related-card, .product-card'
  );
  reveals.forEach(el => el.classList.add('reveal'));

  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('visible');
          }, i * 80);
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach(el => revealObserver.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('visible'));
  }

  // ── Product gallery thumbnails ────────────────────────────────
  const mainImg = document.getElementById('gallery-main-img');
  const thumbs  = document.querySelectorAll('.gallery-thumb');
  if (mainImg && thumbs.length) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        mainImg.src = thumb.dataset.src;
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  // ── Quantity controls ─────────────────────────────────────────
  const qtyInput = document.getElementById('qty');
  const qtyBtns  = document.querySelectorAll('.qty-btn');
  if (qtyInput && qtyBtns.length) {
    qtyBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        let val = parseInt(qtyInput.value) || 1;
        if (btn.dataset.action === 'plus')  val = Math.min(val + 1, 10);
        if (btn.dataset.action === 'minus') val = Math.max(val - 1, 1);
        qtyInput.value = val;
      });
    });
  }

  // ── Variant selection + price update ─────────────────────────
const variantDataEl = document.getElementById('product-variants-json');
const variantIdInput = document.getElementById('variant-id');
const priceDisplay = document.getElementById('price-display');
const comparePriceDisplay = document.getElementById('compare-price-display');

if (variantDataEl) {
  const variants = JSON.parse(variantDataEl.textContent);

  // Construct selected options state
  const selectedOptions = {};

  // Init: pre-select first available variant's options
  const firstAvailable = variants.find(v => v.available) || variants[0];
  if (firstAvailable) {
    firstAvailable.options.forEach((val, i) => {
      selectedOptions[i + 1] = val;
    });
    // Mark initial buttons as active
    document.querySelectorAll('.variant-btn').forEach(btn => {
      if (btn.dataset.value === selectedOptions[btn.dataset.option]) {
        btn.classList.add('active');
      }
    });
  }

  function findMatchingVariant() {
    return variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i + 1])
    );
  }

  function updatePrice(variant) {
    if (!variant || !priceDisplay) return;

    // Format price (Shopify prices are in cents)
    const format = (cents) => {
      return (cents / 100).toLocaleString('fr-FR', {
        style: 'currency',
        currency: 'EUR'
      });
    };

    priceDisplay.textContent = format(variant.price);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      comparePriceDisplay.textContent = format(variant.compare_at_price);
      comparePriceDisplay.style.display = '';
    } else {
      comparePriceDisplay.style.display = 'none';
    }

    // Update variant ID for add to cart
    if (variantIdInput) variantIdInput.value = variant.id;

    // Update button state
    const cartBtn = document.querySelector('.btn-cart');
    if (cartBtn) {
      cartBtn.disabled = !variant.available;
      cartBtn.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
    }
  }

  // Listen to variant button clicks
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const optionPos = btn.dataset.option;
      const optionVal = btn.dataset.value;

      // Deselect siblings
      document.querySelectorAll(`.variant-btn[data-option="${optionPos}"]`)
        .forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      // Update selected options
      selectedOptions[optionPos] = optionVal;

      // Find and apply matching variant
      const match = findMatchingVariant();
      if (match) updatePrice(match);
    });
  });

  // Init price display
  updatePrice(firstAvailable);
}

  // ── Cart quantity live update ─────────────────────────────────
  const cartQtyInputs = document.querySelectorAll('.cart-qty-input');
  cartQtyInputs.forEach(input => {
    let debounceTimer;
    input.addEventListener('change', () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const form = document.getElementById('cart-form');
        if (form) form.submit();
      }, 600);
    });
  });

  // ── AJAX Add to cart ──────────────────────────────────────────
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = productForm.querySelector('.btn-cart');
      const formData = new FormData(productForm);

      btn.textContent = 'Ajout…';
      btn.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          btn.textContent = '✓ Ajouté au panier';
          btn.style.background = '#4a8c4a';

          // Update cart count
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const countEl = document.querySelector('.cart-count');
          if (countEl) {
            countEl.textContent = cart.item_count;
          } else if (cart.item_count > 0) {
            const cartLink = document.querySelector('.header-cart');
            if (cartLink) {
              const badge = document.createElement('span');
              badge.className = 'cart-count';
              badge.textContent = cart.item_count;
              cartLink.appendChild(badge);
            }
          }

          setTimeout(() => {
            btn.textContent = 'Ajouter au panier';
            btn.style.background = '';
            btn.disabled = false;
          }, 2500);
        } else {
          throw new Error('Erreur');
        }
      } catch (err) {
        btn.textContent = 'Erreur — réessayer';
        btn.style.background = '#8c4a4a';
        setTimeout(() => {
          btn.textContent = 'Ajouter au panier';
          btn.style.background = '';
          btn.disabled = false;
        }, 2500);
      }
    });
  }

  // ── Smooth anchor links ───────────────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('promo-toggle');
  const field  = document.getElementById('promo-field');
  const input  = document.getElementById('promo-input');
  const apply  = document.getElementById('promo-apply');
  const msg    = document.getElementById('promo-msg');

  if (!toggle) return;

  toggle.addEventListener('click', () => {
    const isOpen = !field.hidden;
    field.hidden = isOpen;
    toggle.classList.toggle('is-open', !isOpen);
    if (!isOpen) input.focus();
  });

  function submitCode() {
    const code = input.value.trim();
    if (!code) {
      msg.textContent = 'Entrez un code.';
      msg.className = 'cart-promo-msg is-error';
      msg.hidden = false;
      return;
    }

    apply.disabled = true;
    apply.textContent = '…';
    msg.textContent = 'Redirection vers le paiement pour appliquer le code.';
    msg.className = 'cart-promo-msg is-info';
    msg.hidden = false;

    window.location.href = '/checkout?discount=' + encodeURIComponent(code);
  }

  apply.addEventListener('click', submitCode);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') { e.preventDefault(); submitCode(); }
  });
});